import Vue from 'vue'
import store from 'Store'
import Vmodal from 'vue-js-modal'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'
import Notifications from 'vue-notification'
import BrokenImageReplacer from 'Plugins/brokenImageReplacer'
import signalRPlugin from 'Plugins/signalRPlugin'

import GlobalComponents from 'Plugins/globalComponents'
import GlobalDirectives from 'Plugins/globalDirectives'
import onboarding from 'Mixins/onboarding'
import vuexActions from 'Mixins/vuexActions'
import Elmah from 'Plugins/elmah'
import * as VueGoogleMaps from "gmap-vue";
import { getEnvGooglekey } from 'Services/accessUrl'

export const initVue = (pageOptions: object) => {
  Vue.use(GlobalComponents)
  Vue.use(Notifications)
  Vue.use(VueTheMask)
  Vue.use(Vuelidate)
  Vue.use(Vmodal, { dynamic: true })
  Vue.use(BrokenImageReplacer)
  Vue.use(Elmah)
  Vue.use(signalRPlugin)
  Vue.use(VueGoogleMaps, {
    load: {
      key: getEnvGooglekey(process.env.VM_ENV),
    },
    installComponents: false
  });
  Vue.use(GlobalDirectives)

  const mainOptions = {
    el: '#js-vue-app',
    store: store,
    mixins: [ onboarding, vuexActions ],
  }

  return new Vue({ ...pageOptions, ...mainOptions })
}

const createApp = (options: object = {}) => {
  return initVue(options)
}

export default createApp
